import createHintComponent from "../../../../helpers/common/CoreInputText/components/Hint/fabric";
import { INPUT_TEXT_DISPLAY_NAME } from "../../utils/core";

export const Component = createHintComponent(INPUT_TEXT_DISPLAY_NAME);
export default Component;
